
import moment from 'moment-timezone';

import { Pipe, PipeTransform } from '@angular/core';
import { CultureService } from '../services/culture.service';

@Pipe({
    name: 'localTime',
    standalone: false
})
export class localTimePipe implements PipeTransform {

  constructor(
    private cultureService: CultureService
    ) {}

  transform(value: Date, compensateTimeZone: boolean = true): string {

    if (value === null || value === undefined) return null;

    var culture = this.cultureService.getCulture();
    const dte = moment.utc(value);

    if (compensateTimeZone) {
      return dte.tz(culture.TimeZone).format(culture.FormatTime);
    }

    return dte.tz('UTC').format(culture.FormatTime);
  }
}
